import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Danke from "@/pages/Danke";
import { Toaster } from "@/components/ui/sonner";
import CookieBanner from "@/components/honex/CookieBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/danke" element={<Danke />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-center" theme="light" richColors />
    </div>
  );
}

export default App;
